import React, {ReactElement, useEffect, useState} from 'react'
import { translate } from '../../helpers/utils'
import { IToastNotification, ToasterContainer } from '@digicert/dcone-common-ui'
import { NotificationProps } from './Notification.types'
import { useSelector, useDispatch } from 'react-redux'
import { hideNotification } from 'core/actions/Notifications.actions'
import { IAppState } from 'core/store/store'

const Notifications = () : ReactElement => {
  const notificationList = useSelector((state: IAppState) => state.notifications)
  const [notifications, setNotifications] = useState<IToastNotification[]>([])
  const dispatch = useDispatch()
  useEffect(()=> {
    if (notificationList.items[0]) {
      const updatedNotifications =  notificationList.items.map(
        (notification: NotificationProps): IToastNotification => {
          const { title, message } = notification
          const translateMessage = 'translateMessage' in notification ? notification.translateMessage : true
          return {
            ...notification,
            title: title ? title : undefined,
            description: message ? translateMessage && typeof message === 'string' ? translate(message) : message : undefined
          }
        }
      )
      setNotifications(updatedNotifications)
      setTimeout(()=> {
        dispatch(hideNotification(notificationList.items[0].id))
      },2000)
    }
  },[notificationList])

  const hideNotifications = (id: string | number) => {
    setNotifications(notifications?.filter((notification) => notification.id !== id));
  }

  return (
    <>
      <ToasterContainer hideNotification={hideNotifications} notifications={notifications}/>
    </>
  )
}

export default Notifications
